import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Constants } from 'src/assets/constants'

const PAGE_SIZE = Constants.PAGE_SIZE

@Component({
  selector: 'list-pagination',
  styleUrls: ['list-pagination.component.scss'],
  templateUrl: 'list-pagination.component.html',
})
export class ListPagination {
  @Input() listSize: number
  @Output() pageNumber = new EventEmitter<number>()

  public page: number
  public pageSelect: UntypedFormControl = new UntypedFormControl()
  public PAGE_SIZE: number
  public paginationRefresh = true;

  ngOnInit() {
    this.PAGE_SIZE = PAGE_SIZE
    if (this.listSize > PAGE_SIZE) {
      this.changePage(1)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.paginationRefresh = false;
    if (changes.listSize !== undefined) {
      this.changePage(1)
    }
  }

  changePage(newPage: number) {
    setTimeout(() => {
      window.scrollTo({top:0,left:0,behavior:'smooth'})
      this.paginationRefresh = true;
    }, 0);
    if (newPage * PAGE_SIZE < this.listSize + PAGE_SIZE && newPage >= 1) {
      this.page = newPage
      this.pageSelect.setValue(this.page)
      this.pageNumber.emit(this.page)
    }
  }
}
